import { useState } from "react";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import Select from "react-select";

const MWHBootstrap = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeChip, setActiveChip] = useState("Design");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const chipOptions = ["Design", "Planning", "Review", "Closeout"];
  const templateOptions = [
    { value: "design-review", label: "Design review" },
    { value: "submittal-package", label: "Submittal package" },
    { value: "asset-tracker", label: "Asset tracker" },
  ];

  return (
    <div className="project-config-page mwh-bootstrap-showcase">
      <Container className="project-config-shell mwh-bootstrap-showcase__shell">
        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3 mb-4">
          <div>
            <div className="mwh-bootstrap-showcase__eyebrow">
              MWH reusable UI kit
            </div>
            <h1 className="project-config-title mb-2">
              Modern component showcase
            </h1>
            <p className="mwh-bootstrap-showcase__subtitle mb-0">
              A reference page for the newer MWH action buttons, cards, forms,
              tables, and modal treatments used across the app.
            </p>
          </div>
        </div>

        <Row className="g-4">
          <Col lg={6}>
            <Card className="mwh-bootstrap-showcase__panel h-100">
              <Card.Header className="mwh-bootstrap-showcase__panel-header">
                Buttons
              </Card.Header>
              <Card.Body>
                <div className="project-config-actions d-flex align-items-center mb-3">
                  <Button
                    type="button"
                    variant="outline-info"
                    className="project-config-action-btn mwh-btn-primary"
                  >
                    Primary
                  </Button>
                  <Button
                    type="button"
                    variant="outline-success"
                    className="project-config-action-btn mwh-btn-success"
                  >
                    Success
                  </Button>
                  <Button
                    type="button"
                    variant="outline-info"
                    className="project-config-action-btn mwh-btn-info"
                  >
                    Info
                  </Button>
                  <Button
                    type="button"
                    variant="outline-danger"
                    className="project-config-action-btn mwh-btn-danger"
                  >
                    Danger
                  </Button>
                  <Button
                    type="button"
                    variant="outline-warning"
                    className="project-config-action-btn mwh-btn-warning"
                  >
                    Warning
                  </Button>
                </div>
                <div className="project-config-actions d-flex align-items-center mb-3">
                  <Button
                    type="button"
                    variant="outline-info"
                    className="project-config-action-btn mwh-bootstrap-showcase__outline-btn"
                  >
                    Primary outline
                  </Button>
                  <Button
                    type="button"
                    variant="outline-success"
                    className="project-config-action-btn mwh-bootstrap-showcase__outline-btn"
                  >
                    Success outline
                  </Button>
                  <Button
                    type="button"
                    variant="outline-info"
                    className="project-config-action-btn mwh-bootstrap-showcase__outline-btn mwh-bootstrap-showcase__outline-btn--info"
                  >
                    Info outline
                  </Button>
                  <Button
                    type="button"
                    variant="outline-danger"
                    className="project-config-action-btn mwh-bootstrap-showcase__outline-btn"
                  >
                    Danger outline
                  </Button>
                  <Button
                    type="button"
                    variant="outline-warning"
                    className="project-config-action-btn mwh-bootstrap-showcase__outline-btn"
                  >
                    Warning outline
                  </Button>
                </div>
                <div className="mwh-bootstrap-showcase__variant-label">
                  Compact / small variants
                </div>
                <div className="project-config-actions d-flex align-items-center mb-3">
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-info"
                    className="project-config-action-btn mwh-btn-primary mwh-bootstrap-showcase__btn-sm"
                  >
                    Primary small
                  </Button>
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-success"
                    className="project-config-action-btn mwh-btn-success mwh-bootstrap-showcase__btn-sm"
                  >
                    Success small
                  </Button>
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-info"
                    className="project-config-action-btn mwh-btn-info mwh-bootstrap-showcase__btn-sm"
                  >
                    Info small
                  </Button>
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-danger"
                    className="project-config-action-btn mwh-btn-danger mwh-bootstrap-showcase__btn-sm"
                  >
                    Danger small
                  </Button>
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-warning"
                    className="project-config-action-btn mwh-btn-warning mwh-bootstrap-showcase__btn-sm"
                  >
                    Warning small
                  </Button>
                </div>
                <div className="project-config-actions d-flex align-items-center mb-1">
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-info"
                    className="project-config-action-btn mwh-bootstrap-showcase__outline-btn mwh-bootstrap-showcase__btn-sm"
                  >
                    Primary outline small
                  </Button>
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-success"
                    className="project-config-action-btn mwh-bootstrap-showcase__outline-btn mwh-bootstrap-showcase__btn-sm"
                  >
                    Success outline small
                  </Button>
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-info"
                    className="project-config-action-btn mwh-bootstrap-showcase__outline-btn mwh-bootstrap-showcase__outline-btn--info mwh-bootstrap-showcase__btn-sm"
                  >
                    Info outline small
                  </Button>
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-danger"
                    className="project-config-action-btn mwh-bootstrap-showcase__outline-btn mwh-bootstrap-showcase__btn-sm"
                  >
                    Danger outline small
                  </Button>
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-warning"
                    className="project-config-action-btn mwh-bootstrap-showcase__outline-btn mwh-bootstrap-showcase__btn-sm"
                  >
                    Warning outline small
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <Card className="mwh-bootstrap-showcase__panel h-100">
              <Card.Header className="mwh-bootstrap-showcase__panel-header">
                Alerts and status chips
              </Card.Header>
              <Card.Body>
                <Alert className="mwh-bootstrap-showcase__alert mwh-bootstrap-showcase__alert--info">
                  This alert uses the same soft-glass surface and rounded
                  treatment as the refreshed project panels.
                </Alert>
                <Alert className="mwh-bootstrap-showcase__alert mwh-bootstrap-showcase__alert--success">
                  Success states are shown with the same green accent used in
                  the app’s action buttons.
                </Alert>
                <div className="d-flex flex-wrap gap-2">
                  <Badge className="mwh-bootstrap-showcase__pill">
                    Primary
                  </Badge>
                  <Badge className="mwh-bootstrap-showcase__pill mwh-bootstrap-showcase__pill--success">
                    Success
                  </Badge>
                  <Badge className="mwh-bootstrap-showcase__pill mwh-bootstrap-showcase__pill--warning">
                    Warning
                  </Badge>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="g-4 mt-1">
          <Col lg={6}>
            <Card className="mwh-bootstrap-showcase__panel h-100">
              <Card.Header className="mwh-bootstrap-showcase__panel-header">
                Form controls
              </Card.Header>
              <Card.Body className="mwh-bootstrap-showcase__form-controls project-config-modal__body">
                <Form onSubmit={(event) => event.preventDefault()}>
                  <Form.Group className="mb-3" controlId="showcaseName">
                    <Form.Label>Project name</Form.Label>
                    <Form.Control
                      className="mb-2"
                      type="text"
                      placeholder="Enter a project name"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="showcaseSelect">
                    <Form.Label>Choose a template</Form.Label>
                    <Select
                      className="mb-2"
                      classNamePrefix="project-config-select"
                      menuPortalTarget={document.body}
                      options={templateOptions}
                      value={selectedTemplate}
                      onChange={(option) => setSelectedTemplate(option)}
                      isSearchable={true}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="showcaseTextArea">
                    <Form.Label>Comments</Form.Label>
                    <Form.Control as="textarea" rows={3} />
                  </Form.Group>
                  <div className="project-config-actions d-flex align-items-center mb-3">
                    <Button
                      type="button"
                      variant="outline-info"
                      className="project-config-action-btn mwh-btn-primary"
                    >
                      Save changes
                    </Button>
                    <Button
                      type="button"
                      variant="outline-warning"
                      className="project-config-action-btn mwh-btn-warning"
                    >
                      Cancel
                    </Button>
                  </div>
                  <Form.Check
                    type="checkbox"
                    label="Include supporting documents"
                  />
                </Form>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <Card className="mwh-bootstrap-showcase__panel h-100">
              <Card.Header className="mwh-bootstrap-showcase__panel-header">
                Cards, table, and modal
              </Card.Header>
              <Card.Body>
                <Card className="card text-white mb-3 mwh-bootstrap-showcase__inline-card mwh-bootstrap-showcase__screenshot-card">
                  <div className="card-header mwh-bootstrap-showcase__screenshot-card-header">
                    <div
                      className="mwh-bootstrap-showcase__screenshot-card-title"
                      data-active="true"
                    >
                      Reusable summary card
                    </div>
                  </div>
                  <div className="card-body mwh-bootstrap-showcase__screenshot-card-body">
                    <div className="mwh-bootstrap-showcase__screenshot-card-preview">
                      <div className="mwh-bootstrap-showcase__screenshot-card-preview-state">
                        Preview
                      </div>
                    </div>
                    <div className="mwh-bootstrap-showcase__screenshot-card-content">
                      <div className="mwh-bootstrap-showcase__screenshot-card-meta">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                      </div>
                      <div className="mwh-bootstrap-showcase__screenshot-card-actions">
                        <Button
                          type="button"
                          className="project-config-action-btn mwh-btn-primary"
                          onClick={() => setShowModal(true)}
                        >
                          Open modal
                        </Button>
                      </div>
                    </div>
                  </div>
                </Card>
                <div className="mwh-bootstrap-showcase__variant-label mt-1">
                  Table variants
                </div>
                <div className="mwh-bootstrap-showcase__table-options">
                  <div>
                    <div className="mwh-bootstrap-showcase__table-option-label">
                      Alternate striping
                    </div>
                    <div className="mwh-bootstrap-showcase__object-table mwh-bootstrap-showcase__object-table--striped">
                      <Table responsive className="mwh-bootstrap-showcase__table mb-0">
                        <thead>
                          <tr>
                            <th>Component</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Buttons</td>
                            <td>Ready</td>
                          </tr>
                          <tr>
                            <td>Forms</td>
                            <td>Ready</td>
                          </tr>
                          <tr>
                            <td>Cards</td>
                            <td>Ready</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>

                  <div>
                    <div className="mwh-bootstrap-showcase__table-option-label">
                      Solid rows
                    </div>
                    <div className="mwh-bootstrap-showcase__object-table mwh-bootstrap-showcase__object-table--plain">
                      <Table responsive className="mwh-bootstrap-showcase__table mb-0">
                        <thead>
                          <tr>
                            <th>Component</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Buttons</td>
                            <td>Ready</td>
                          </tr>
                          <tr>
                            <td>Forms</td>
                            <td>Ready</td>
                          </tr>
                          <tr>
                            <td>Cards</td>
                            <td>Ready</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="g-4 mt-1">
          <Col lg={12}>
            <Card className="mwh-bootstrap-showcase__panel">
              <Card.Header className="mwh-bootstrap-showcase__panel-header">
                Toggle chips and stage selection
              </Card.Header>
              <Card.Body>
                <div className="d-flex flex-wrap gap-2 mb-3 mwh-bootstrap-showcase__chip-wrap">
                  {chipOptions.map((option) => (
                    <Button
                      type="button"
                      key={option}
                      className={`mwh-bootstrap-showcase__chip mwh-bootstrap-showcase__hub-toggle${
                        activeChip === option ? " is-active" : ""
                      }`}
                      onClick={() => setActiveChip(option)}
                    >
                      {option}
                    </Button>
                  ))}
                </div>
                <Alert className="mwh-bootstrap-showcase__alert mwh-bootstrap-showcase__alert--info mb-0">
                  Current selection: <strong>{activeChip}</strong>. This pattern
                  is a compact way to show project stages or filter choices
                  without introducing heavier navigation.
                </Alert>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          dialogClassName="project-config-modal"
        >
          <Modal.Header closeButton className="project-config-modal__header">
            <Modal.Title>Modal example</Modal.Title>
          </Modal.Header>
          <Modal.Body className="project-config-modal__body">
            This modal follows the same surface, spacing, and accent language as
            the rest of the app.
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              variant="outline-warning"
              className="project-config-action-btn mwh-btn-warning"
              onClick={() => setShowModal(false)}
            >
              Close
            </Button>
            <Button
              type="button"
              variant="outline-info"
              className="project-config-action-btn mwh-btn-primary"
              onClick={() => setShowModal(false)}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};

export default MWHBootstrap;
